<template>
    <div class="events-board-parent-wrap">
        <v-card class="modal-maincard">

            <v-card-text class="wrapperFormModal">
                <v-card flat>
                    <v-card-text>
                        <v-form ref="form" lazy-validation>
                            <template v-for="(item, itemKey) in dataSource">
                                <v-row no-gutters v-if="item.group.label" :key=skey+itemKey+item.group.name>
                                    <v-col  cols="12" sm="12" md="12">
                                        <label class="f-label">{{$t(item.group.label)}}</label>
                                    </v-col>
                                </v-row>
                                <template v-for="(value, valueKey) in item.values">
                                    <!-- <div :key="valueKey">
                                        <div>{{value}}</div>
                                        <div>{{valueKey}}</div>
                                    </div> -->
                                    <component 
                                        :is="value.field.componentName" 
                                        :items="value.field.reference"                                            
                                        :key=skey+itemKey+valueKey 
                                        :label="value.field.label" 
                                        :value="value.field.value" 
                                        @input="e => updateDataSource({ property: `[${itemKey}].values[${valueKey}].field.value`, value: e })" 
                                        :rules="requiredRule"                                            
                                    />
                                </template>
                            </template>
                        </v-form>
                    
                    </v-card-text>
                </v-card>  
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isValid"
                >
                    {{ $t("Ок") }} 
                </v-btn>

                <!-- <v-btn 
                    color="blue-grey" 
                    text
                    depressed 
                    @click="cancel"
                >
                    {{$t("Отменить")}}
                </v-btn> -->

            </v-card-actions>

        </v-card>
    </div>
</template>

<script>
// import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';

// import sys from '@/services/system';
// import { httpAPI } from "@/api/httpAPI";

export default {
    name: "DynamicFormView",
    components: {

    },
    data() {
        return {

        }
    },
    asyncComputed: {

    },
    computed: {
        ...mapGetters('sep/dynamicform', ['isValid', 'dataSource', 'skey']),      
        ...mapGetters({ requiredRule: 'getRequiredRule' }),  
    },
    methods: {
        ...mapActions('sep/dynamicform', ['ok', /*'cancel',*/ 'updateDataSource']),   
        validateForm() {
            this.$refs?.form?.validate();    
        },

    },
    async created() {

    },
    mounted() {

    },
    beforeDestroy() {

    },
    watch: {
        
    }
}
</script>